export default {
	save: 'Modificările au fost salvate cu succes',
	error: 'Greşeală. Contactați asistența',
	'old password was incorrect': 'Parola veche era incorectă',
	templateDuplicated: 'Șablonul duplicat cu succes',


}